
import React, { Component } from 'react'
import moment from 'moment-timezone';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "./../redux/bindActionCretor";
import AppConfigForm from '../component/Mobile/AppConfigForm';

class AppConfiguration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lastUpdatedAt: null,
            lastUpdatedBy: null,
        };
        this.handleLastUpdated = this.handleLastUpdated.bind(this);
    }

    handleLastUpdated(updatedAt, updatedBy) {
        this.setState({ lastUpdatedAt: updatedAt, lastUpdatedBy: updatedBy });
    }

    render() {
        const { lastUpdatedAt, lastUpdatedBy } = this.state;

        return (
            <React.Fragment>
                <div className="right_side_wrapper">
                    <div className="bradcrumb disp_flex d_flex_justify_spacebt d_flex_align_center">
                        <ul className="disp_flex">
                            <li>App Configuration</li>
                        </ul>
                    </div>
                    <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                        <p></p>
                        {lastUpdatedAt && (
                            <p className="update_date">
                                Last Update: {moment(lastUpdatedAt).tz('America/Denver').format('h:mm A')} MT &mdash; {moment(lastUpdatedAt).format('MM/DD/YY')}
                                {lastUpdatedBy && ` by ${lastUpdatedBy.fname} ${lastUpdatedBy.lname}`}
                            </p>
                        )}
                    </div>
                    <AppConfigForm history={this.props.history} onLastUpdated={this.handleLastUpdated} />
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => bindActionCreators(ActCreators, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(AppConfiguration);
